import React from 'react';

import useSearchStore from '../../_global/js/SearchStore';

export default function SearchFilterContainer() {
    const resetSearchFacetSelections = useSearchStore(
        (state) => state.resetSearchFacetSelections
    );

    /**
     * Respond to changes to the "clear all tags" input
     *
     * @returns void
     */
    const onClearTagsClick = () => {
        // Reset all stored Facet data
        resetSearchFacetSelections();
    };

    return (
        <label className="facet-group__checkbox-label" htmlFor="clear-all">
            <input
                className="facet-group__checkbox"
                id="clear-all"
                name="clear-all"
                onChange={onClearTagsClick}
                type="checkbox"
            />
            <span className="pill input light-bg">
                Clear all{' '}
                <span className="facet-group__results-remove">
                    <svg className="svg-icon">
                        <use href="#rse-close" />
                    </svg>
                </span>
            </span>
        </label>
    );
}
